import { useEffect } from "react";

import { DeviceAuthProvider, useDeviceAuth } from "./auth/DeviceAuthContext.js";
import { BundleLoader } from "./BundleLoader.js";
import { PlaySessionProvider } from "./session/PlaySessionContext.js";

function WaitingForVenue() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#0a0b10",
        color: "#e2e4ea",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <h1 style={{ fontSize: "32px", marginBottom: "16px" }}>Device Registered</h1>
      <p style={{ color: "#8b90a0", fontSize: "18px" }}>
        Waiting for venue assignment...
      </p>
      <p style={{ color: "#555a6e", fontSize: "14px", marginTop: "8px" }}>
        Assign this device to a venue in the admin portal to start serving content.
      </p>
    </div>
  );
}

function AppContent() {
  const { session, loading } = useDeviceAuth();

  useEffect(() => {
    if (!loading && !session) {
      const userPortalUrl = window.serverConfig?.USER_PORTAL_URL || "http://localhost:6177";
      window.location.href = `${userPortalUrl}/start`;
    }
  }, [loading, session]);

  if (loading || !session) {
    return null;
  }

  if (!session.venue_id) {
    return <WaitingForVenue />;
  }

  return (
    <PlaySessionProvider>
      <BundleLoader />
    </PlaySessionProvider>
  );
}

export function App() {
  return (
    <DeviceAuthProvider>
      <AppContent />
    </DeviceAuthProvider>
  );
}
